import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, normalizeClass as _normalizeClass, createVNode as _createVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createElementBlock as _createElementBlock, resolveComponent as _resolveComponent, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-1ee23e1c"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  class: /*#__PURE__*/_normalizeClass(`tw-px-[20px] tw-pb-[40px] sm:tw-px-[40px] tw-pt-[20px] sm:tw-pt-[40px] tw-flex tw-flex-col tw-gap-10 tw-w-full`)
}
const _hoisted_2 = { class: "tw-text-[15px] tw-flex tw-flex-col tw-gap-[25px] tw-items-start tw-justify-between tw-text-[#211F58] tw-w-full" }
const _hoisted_3 = { class: "tw-relative tw-w-full" }
const _hoisted_4 = { class: "tw-text-[16px] tw-leading-[130%] tw-font-semibold" }
const _hoisted_5 = { class: "tw-pr-[20px] tw-text-[#878787] tw-text-[13px] tw-font-normal tw-leading-normal tw-mt-[10px]" }
const _hoisted_6 = { class: "tw-relative tw-w-full tw-flex tw-flex-col tw-gap-[20px]" }
const _hoisted_7 = { class: "tw-flex tw-flex-row tw-justify-between tw-items-center tw-w-full" }
const _hoisted_8 = { class: "tw-flex tw-flex-row tw-justify-end tw-items-center" }

import {
  getComponentUiText,
  hasInvalidDomainChars,
  invalidCharPhoneNumber,
  IsPhoneNumber,
  isUrlFacingWeb,
} from "../../utils/utilities";
import { computed, onMounted, Ref, ref, watch } from "vue";
import ModalHeader from "../common/modalHeader.vue";
import Modal from "../common/modal.vue";
import BaseInput from "../common/form/baseInput.vue";
import useVuelidate from "@vuelidate/core";
import { helpers, required } from "@vuelidate/validators";
import WysiwygEditor from "../common/wysiwygEditor.vue";
import ButtonShowDuplicateAssessment from "../common/setting/buttonShowDuplicateAssessment.vue";
import store from "@/store";
import eventEmitter, { EmitterEvents } from "@/utils/eventEmitter";
import { IModalMessage } from "@/interfaces/common/common";
import { ARE_YOU_SURE_TYPES, MODAL_NAME } from "@/utils/constants";
import { IVendorProvider } from "@/interfaces/vendor";
import { LottieAnimation } from "lottie-web-vue";
import ProgressAnimation from "../../assets/animation/progress_dark.json";


export default /*#__PURE__*/_defineComponent({
  __name: 'manageVendorDetailModal',
  props: {
  show: {
    type: Boolean,
    required: false,
  },
  data: {
    type: Object,
    required: true,
    default: () => ({
      name: "",
      description: "",
      url: "",
      phone: "",
      urlSupport: "",
      phoneSupport: "",
      notes: "",
    }),
  },
},
  emits: ["update:show", "update:data", "update:close"],
  setup(__props, { emit }) {

const props = __props;




let showRef = ref(props.show);

const searchValue = ref("");
const isShowVendorDetails = ref(false);
const seletedAssessmentRow = ref([]);
const isLoading = ref(false);
const isLoadingDelete = ref(false);
const formModel = ref(props.data);

const rules = {
  name: {
    required: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-required-error-1"),
      required,
    ),
  },
  description: {},
  url: {
    url: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-url-web-service-error-1"),
      (url) => isUrlFacingWeb(url) || !url,
    ),
    isValidCharacter: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-url-web-service-error-1"),
      (url: string) => hasInvalidDomainChars(url) || !url,
    ),
  },
  phone: {
    phoneNumber: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      (phone) => IsPhoneNumber(phone) || !phone,
    ),
    isValidCharacter: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      (phone) => invalidCharPhoneNumber(phone) || !phone,
    ),
  },
  urlSupport: {
    url: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-url-web-service-error-1"),
      (url) => isUrlFacingWeb(url) || !url,
    ),
    isValidCharacter: helpers.withMessage(
      () => getComponentUiText("app-common-form-value-url-web-service-error-1"),
      (url: string) => hasInvalidDomainChars(url) || !url,
    ),
  },
  phoneSupport: {
    phoneNumber: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      (phone) => IsPhoneNumber(phone) || !phone,
    ),
    isValidCharacter: helpers.withMessage(
      () => getComponentUiText("app-form-validate-invalid-phone-number-1"),
      (phone) => invalidCharPhoneNumber(phone) || !phone,
    ),
  },
  notes: {},
};

const $v = useVuelidate(rules, formModel as any);
const vendorEdit: Ref<IVendorProvider> = ref({});

onMounted(() => {});

const handleCloseModal = (fromModal) => {
  if (!fromModal) {
    const check = checkInputField();
    if (check) return;
  }
  showRef.value = false;
  emit("update:show", showRef.value);
};

const checkInputField = () => {
  return Object.entries(formModel.value).filter(([key, value]) =>
    !vendorEdit.value?.id
      ? value
      : value !== vendorEdit.value[key] && (value || vendorEdit.value[key]),
  ).length;
};

const handleResetAndCloseForm = () => {
  showRef.value = false;
  emit("update:show", showRef.value);
  vendorEdit.value = {};
  formModel.value = {
    name: "",
    description: "",
    url: "",
    phone: "",
    urlSupport: "",
    phoneSupport: "",
    notes: "",
  };
  $v.value.$reset();
};

const handleSubmitVendor = async () => {
  try {
    isLoading.value = true;
    const isValid = await $v.value.$validate();
    if (!isValid) {
      return;
    }

    const vendorData: { [k: string]: string | number } = Object.fromEntries(
      Object.entries(formModel.value).filter(([key, value]) =>
        !vendorEdit.value?.id
          ? value
          : value !== vendorEdit.value[key] && (value || vendorEdit.value[key]),
      ),
    );
    if (!Object.entries(vendorData).length) {
      handleCloseModal(false);
      return;
    }
    if (vendorEdit.value?.id) {
      vendorData.id = vendorEdit.value.id;
    }

    const res = await store.dispatch("Vendor/addProvider", vendorData);
    if (res) {
      handleResetAndCloseForm();
    }
  } catch (error) {
    console.error("Error submitting vendor data:", error);
  } finally {
    isLoading.value = false;
  }
};

const handleDeleteVendor = async (item: IVendorProvider) => {
  try {
    isLoadingDelete.value = true;
    const res = await store.dispatch("Vendor/deleteProvider", item.id);
    if (res && item.id === vendorEdit.value.id) {
      handleCloseModal(false);
    }
  } catch (error) {
    console.error("Error delete vendor data:", error);
  } finally {
    isLoadingDelete.value = false;
  }
};

const onSelectVendor = (selectedRows: any) => {
  seletedAssessmentRow.value = selectedRows;
};

const onEditVendor = (item: IVendorProvider) => {
  isShowVendorDetails.value = true;
  vendorEdit.value = item;
  formModel.value = {
    name: item.name ?? "",
    description: item.description ?? "",
    url: item.url ?? "",
    phone: item.phone ?? "",
    urlSupport: item.urlSupport ?? "",
    phoneSupport: item.phoneSupport ?? "",
    notes: item.notes ?? "",
  };
};

const onDeleteVendor = (item: IVendorProvider) => {
  const emitData: IModalMessage = {
    component: MODAL_NAME.MODAL_RECOMMEN_ARE_YOU_SURE,
    properties: {
      value: {},
      title: getComponentUiText(
        "app-modal-manage-vendor-modal-delete-vendor-title-1",
      ),
      description: getComponentUiText(
        "app-modal-manage-vendor-delete-vendor-description-1",
      ),
      list: [],
      buttonText: getComponentUiText(
        "app-modal-manage-vendor-delete-vendor-button-title-1",
      ),
      isShowBtnCancel: true,
      blueText: getComponentUiText(
        "app-modal-manage-vendor-modal-delete-vendor-cancel-button-title-1",
      ),
      buttonRed: true,
      hiddenHelp: false,
      type: ARE_YOU_SURE_TYPES.assessmentTemplateDelete,
      updateDataFunction: async () => {
        const res = await store.dispatch("Vendor/deleteProvider", item.id);
        // if (res && item.id === vendorEdit.value.id) {
        //   handleResetAndCloseForm();
        // }
      },
    },
    events: {
      "update:data": async () => {
        store.dispatch(
          "LoadingAreYouSureButtonModal/setLoadingRedButton",
          true,
        );
        const res = await store.dispatch("Vendor/deleteProvider", item.id);
        if (res && item.id === vendorEdit.value.id) {
          handleResetAndCloseForm();
        }
        store.dispatch(
          "LoadingAreYouSureButtonModal/setLoadingRedButton",
          false,
        );
      },
    },
  };
  eventEmitter.emit(EmitterEvents.OPEN_MODAL, emitData);
};

watch(
  () => props.data,
  (item) => {
    vendorEdit.value = item;
    formModel.value = {
      name: item.name ?? "",
      description: item.description ?? "",
      url: item.url ?? "",
      phone: item.phone ?? "",
      urlSupport: item.urlSupport ?? "",
      phoneSupport: item.phoneSupport ?? "",
      notes: item.notes ?? "",
    };
  },
  {
    immediate: true,
  },
);

return (_ctx: any,_cache: any) => {
  const _component_b_button = _resolveComponent("b-button")!

  return (_openBlock(), _createBlock(Modal, {
    class: "tw-max-w-[1040px]",
    visible: _unref(showRef),
    onClose: _cache[12] || (_cache[12] = () => handleCloseModal(false))
  }, {
    default: _withCtx(() => [
      _createVNode(ModalHeader, {
        title: _unref(getComponentUiText)('app-modal-manage-vendor-title-1'),
        class: _normalizeClass('tw-px-[20px] sm:tw-px-[40px]'),
        onClose: _cache[0] || (_cache[0] = () => handleCloseModal(true))
      }, null, 8, ["title"]),
      _createElementVNode("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, [
          _createElementVNode("div", _hoisted_3, [
            _createElementVNode("div", _hoisted_4, [
              _createTextVNode(_toDisplayString(_unref(getComponentUiText)("app-modal-manage-vendor-details-title-1")) + " ", 1),
              _createVNode(ButtonShowDuplicateAssessment, {
                "id-popover": 'popover-vendor-current-details',
                "custom-class": 'tw-w-[max-content]  md:tw-max-w-[350px] lg:tw-max-w-[470px]',
                classes: `!tw-leading-none tw-ml-[10px]`
              })
            ]),
            _createElementVNode("div", _hoisted_5, _toDisplayString(_unref(getComponentUiText)("app-modal-manage-vendor-details-decription-1")), 1)
          ]),
          _createElementVNode("div", _hoisted_6, [
            _createVNode(BaseInput, {
              id: "name",
              modelValue: formModel.value.name,
              "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((formModel.value.name) = $event)),
              validation: _unref($v).name,
              container: 'tw-w-full ',
              "class-name": '!tw-items-center !tw-mt-[0px] tw-text-[#231F20]',
              "data-cy-id": "vendor-name-input",
              "input-class": '!tw-h-[56px]',
              label: _unref(getComponentUiText)('app-modal-manage-vendor-name-title-1'),
              placeholder: 
              _unref(getComponentUiText)('app-modal-manage-vendor-name-placeholder-1')
            ,
              onBlur: _cache[2] || (_cache[2] = 
              () => {
                _unref($v).name.$validate();
              }
            )
            }, null, 8, ["modelValue", "validation", "label", "placeholder"]),
            _createVNode(BaseInput, {
              id: "url",
              modelValue: formModel.value.url,
              "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((formModel.value.url) = $event)),
              validation: _unref($v).url,
              container: 'tw-w-full ',
              "class-name": '!tw-items-center !tw-mt-[0px] tw-text-[#231F20]',
              "data-cy-id": "vendor-url-input",
              "input-class": '!tw-h-[56px]',
              label: 
              _unref(getComponentUiText)(
                'app-modal-manage-vendor-current-vendor-table-url-title-1',
              ).toLocaleUpperCase()
            ,
              placeholder: 
              _unref(getComponentUiText)(
                'app-modal-manage-vendor-input-support-url-placeholder-1',
              )
            ,
              onBlur: () => {}
            }, null, 8, ["modelValue", "validation", "label", "placeholder"]),
            _createVNode(BaseInput, {
              id: "phone",
              modelValue: formModel.value.phone,
              "onUpdate:modelValue": _cache[4] || (_cache[4] = ($event: any) => ((formModel.value.phone) = $event)),
              validation: _unref($v).phone,
              container: 'tw-w-full ',
              "class-name": '!tw-items-center !tw-mt-[0px] tw-text-[#231F20]',
              "data-cy-id": "vendor-phone-input",
              "input-class": '!tw-h-[56px]',
              label: 
              _unref(getComponentUiText)('app-modal-manage-vendor-input-phone-title-1')
            ,
              placeholder: 
              _unref(getComponentUiText)(
                'app-modal-manage-vendor-input-support-phone-placeholder-1',
              )
            ,
              onBlur: () => {}
            }, null, 8, ["modelValue", "validation", "label", "placeholder"]),
            _createVNode(BaseInput, {
              id: "supportUrl",
              modelValue: formModel.value.urlSupport,
              "onUpdate:modelValue": _cache[5] || (_cache[5] = ($event: any) => ((formModel.value.urlSupport) = $event)),
              validation: _unref($v).urlSupport,
              container: 'tw-w-full ',
              "class-name": '!tw-items-center !tw-mt-[0px] tw-text-[#231F20]',
              "data-cy-id": "vendor-support-url-input",
              "input-class": '!tw-h-[56px]',
              label: 
              _unref(getComponentUiText)(
                'app-modal-manage-vendor-input-support-url-title-1',
              )
            ,
              placeholder: 
              _unref(getComponentUiText)(
                'app-modal-manage-vendor-input-support-url-placeholder-1',
              )
            ,
              onBlur: () => {}
            }, null, 8, ["modelValue", "validation", "label", "placeholder"]),
            _createVNode(BaseInput, {
              id: "supportPhone",
              modelValue: formModel.value.phoneSupport,
              "onUpdate:modelValue": _cache[6] || (_cache[6] = ($event: any) => ((formModel.value.phoneSupport) = $event)),
              validation: _unref($v).phoneSupport,
              container: 'tw-w-full ',
              "class-name": '!tw-items-center !tw-mt-[0px] tw-text-[#231F20]',
              "data-cy-id": "vendor-support-phone-input",
              "input-class": '!tw-h-[56px]',
              label: 
              _unref(getComponentUiText)(
                'app-modal-manage-vendor-input-support-phone-title-1',
              )
            ,
              placeholder: 
              _unref(getComponentUiText)(
                'app-modal-manage-vendor-input-support-phone-placeholder-1',
              )
            ,
              onBlur: () => {}
            }, null, 8, ["modelValue", "validation", "label", "placeholder"])
          ]),
          _createVNode(BaseInput, {
            id: "description",
            modelValue: formModel.value.description,
            "onUpdate:modelValue": _cache[8] || (_cache[8] = ($event: any) => ((formModel.value.description) = $event)),
            validation: _unref($v).description,
            container: 'tw-w-full ',
            "class-name": '!tw-mt-[0px] tw-text-[#231F20]',
            "label-class": 'sm:tw-mt-[9px]',
            "input-class": '!tw-h-[56px]',
            label: 
            _unref(getComponentUiText)(
              'app-modal-manage-vendor-current-vendor-table-description-title-1',
            )
          ,
            placeholder: 
            _unref(getComponentUiText)(
              'app-modal-manage-vendor-description-placeholder-1',
            )
          ,
            onBlur: () => {}
          }, {
            default: _withCtx(() => [
              _createVNode(WysiwygEditor, {
                modelValue: formModel.value.description,
                "onUpdate:modelValue": _cache[7] || (_cache[7] = ($event: any) => ((formModel.value.description) = $event)),
                placeholder: 
              _unref(getComponentUiText)(
                'app-modal-manage-vendor-description-placeholder-1',
              )
            ,
                "data-cy-id": "vendor-description-input",
                "include-image": false,
                "is-disabled": false
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["modelValue", "validation", "label", "placeholder"]),
          _createVNode(BaseInput, {
            id: "notes",
            modelValue: formModel.value.notes,
            "onUpdate:modelValue": _cache[10] || (_cache[10] = ($event: any) => ((formModel.value.notes) = $event)),
            validation: _unref($v).notes,
            container: 'tw-w-full ',
            "class-name": '!tw-mt-[0px] tw-text-[#231F20] !tw-items-start',
            "label-class": 'sm:tw-mt-[9px]',
            "input-class": '!tw-h-[56px]',
            label: _unref(getComponentUiText)('app-modal-manage-vendor-notes-title-1'),
            placeholder: 
            _unref(getComponentUiText)(
              'app-vendor-dropdown-placehoder-base-input-name-1',
            )
          ,
            onBlur: () => {}
          }, {
            default: _withCtx(() => [
              _createVNode(WysiwygEditor, {
                modelValue: formModel.value.notes,
                "onUpdate:modelValue": _cache[9] || (_cache[9] = ($event: any) => ((formModel.value.notes) = $event)),
                placeholder: 
              _unref(getComponentUiText)('app-modal-manage-vendor-notes-placeholder-1')
            ,
                "data-cy-id": "vendor-notes-input",
                "include-image": false,
                "is-disabled": false
              }, null, 8, ["modelValue", "placeholder"])
            ]),
            _: 1
          }, 8, ["modelValue", "validation", "label", "placeholder"])
        ]),
        _createElementVNode("div", _hoisted_7, [
          _createElementVNode("div", null, [
            (vendorEdit.value.id)
              ? (_openBlock(), _createElementBlock("button", {
                  key: 0,
                  "data-cy": "create-and-upate-assessment-create-btn",
                  class: _normalizeClass(`tw-flex tw-items-center tw-h-[39px] tw-px-[18px] tw-gap-2.5 tw-rounded-[26.909px] tw-bg-[#F7553C] tw-text-white tw-text-center tw-text-[15px] tw-not-italic tw-font-[500] tw-leading-[100%]
            hover:tw-bg-[#d84d37] ${
              isLoadingDelete.value ? 'tw-overflow-hidden' : 'tw-py-3'
            } createBtn`),
                  onClick: _cache[11] || (_cache[11] = () => handleDeleteVendor(vendorEdit.value))
                }, [
                  (isLoadingDelete.value)
                    ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                        key: 0,
                        class: _normalizeClass('tw-h-[39px] tw-w-[39px] tw-absolute tw-left-[62px]'),
                        "animation-data": _unref(ProgressAnimation),
                        "auto-play": true,
                        loop: true
                      }, null, 8, ["animation-data"]))
                    : _createCommentVNode("", true),
                  _createElementVNode("div", {
                    class: _normalizeClass(`${isLoadingDelete.value ? 'tw-mt-[60px]' : ''}`)
                  }, _toDisplayString(_unref(getComponentUiText)(
                  "app-modal-manage-vendor-button-delete-title-1",
                )), 3)
                ], 2))
              : _createCommentVNode("", true)
          ]),
          _createElementVNode("div", _hoisted_8, [
            _createVNode(_component_b_button, {
              style: {"line-height":"100%","border":"2px solid","height":"39px"},
              variant: "primary",
              class: "tw-w-fit tw-mr-[10px] tw-shadow-none tw-bg-[#fff] tw-text-[#387DFF] tw-px-[18px] tw-text-[15px] tw-font-medium tw-rounded-[27px]",
              type: "submit",
              onClick: handleResetAndCloseForm
            }, {
              default: _withCtx(() => [
                _createTextVNode(_toDisplayString(_unref(getComponentUiText)(
                "app-modal-manage-vendor-button-cancel-title-1",
              )), 1)
              ]),
              _: 1
            }),
            _createElementVNode("button", {
              "data-cy": "create-and-upate-assessment-create-btn",
              class: _normalizeClass(`tw-h-[39px] tw-px-[18px] tw-gap-2.5 tw-rounded-[26.909px] tw-bg-[#387DFF] tw-text-white tw-text-center tw-text-[15px] tw-not-italic tw-font-[500] tw-leading-[100%]
              hover:tw-bg-[#096cdb] ${
                isLoading.value ? 'tw-overflow-hidden' : 'tw-py-3'
              } createBtn`),
              onClick: handleSubmitVendor
            }, [
              (isLoading.value)
                ? (_openBlock(), _createBlock(_unref(LottieAnimation), {
                    key: 0,
                    class: _normalizeClass('tw-h-[39px] tw-w-[39px] tw-absolute'),
                    "animation-data": _unref(ProgressAnimation),
                    "auto-play": true,
                    loop: true
                  }, null, 8, ["animation-data"]))
                : _createCommentVNode("", true),
              _createElementVNode("div", {
                class: _normalizeClass(`${isLoading.value ? 'tw-mt-[39px]' : ''}`)
              }, _toDisplayString(_unref(getComponentUiText)(
                  "app-modal-manage-vendor-button-save-title-1",
                )), 3)
            ], 2)
          ])
        ])
      ])
    ]),
    _: 1
  }, 8, ["visible"]))
}
}

})